import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { revalidate } from '@/services/revalidate/revalidate';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';

const useAddPremiumStoreInfo = () => {
  const navigate = useNavigate();
  const { mutateAsync, isPending } = useMutation('createPremiumStoreInfo', {
    onSuccess: async (res) => {
      toast.success(res.message);
      void navigate({ to: '/store-information/premium-stores' });
      await revalidate(['clubBasicInfo', 'availableTime', 'clubSchedule']);
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutateAsync, isSubmitting: isPending };
};

export default useAddPremiumStoreInfo;
